<template>
  <div class="class-list">
    <GlobalInfoBar
      title="客户列表"
      content="查看店员下单时填写的旧机客户信息"
    />
    <!-- <Info/> -->
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <From />
      </div>
      <Table />
    </GlobalChunk>
  </div>
</template>

<script>
import From from "./Form";
import Table from "./Table";
import _api from "@/utils/request";
export default {
  name: "class-list",
  components: {
    From,
    Table,
  },
  data() {
    return {
    };
  },
  created(){
  },
  methods: {
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.class-list{
}
</style>